import { debugInterceptor } from './debug.interceptor';
import { domainInterceptor } from './domain.interceptor';
import { headersInterceptor } from './headers.interceptor';
import { authInterceptor } from './auth.interceptor';
import { responseInterceptor } from './response.interceptor';
import { HttpInterceptorFn } from '@angular/common/http';

export const httpInterceptors: HttpInterceptorFn[] = [
    domainInterceptor,
    headersInterceptor,
    debugInterceptor,
    authInterceptor,
    responseInterceptor,
];
